
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(0[234]1|[45]79|13|182|677|775|794|874)|2(8(61|89|99)|[27]75|133|209|377|619)|5(9(6[356]|47|51|94)|3([027]9|37|85)|6(37|4|91)|003|583)|6(6(23|52|96)|(20|27|79)1|162|419|593|732|978)|1(7(15|25|33|89)|8(07|19|33|43|44)|(10|20|53)9)|8(0(13|25|57|6)|15[45]|9(11|47|85)|425|751|791|852)|7(5(31|47|85|88)|(19|73|86)5|203|254|379|477)|3(3(41|7|79)|(00|4|53|62)5|[49]43|(59|69|88)7|054|702|721|92)|9(9(|24|47|98)|05|283|39|42|457|600|614|724|833))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
